import { combineReducers } from '@reduxjs/toolkit';
import { subjectsReducer } from './reducers/subjects-reducer';
import type { ISubjectState } from './interfaces';

export default combineReducers<ISubjectState>({
  subjectsReducer
});
